import React, { Component } from 'react'
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip } from 'recharts'
import { Spin } from 'antd'
import { getDaysArrayByMonth } from '../../util'
import moment from 'moment'
import D3Funnel from 'd3-funnel'

class ColapsePanel extends Component {
  constructor(props) {
    super(props)
    this.funnelRef = React.createRef()
  }

  componentDidUpdate() {
    const { loadingLeadsPerMonth } = this.props
    if (!loadingLeadsPerMonth) {
      this.mountFunnel()
    }
  }

  mountDataSet = () => {
    const { leadsOfMonth } = this.props
    const chartLabels = getDaysArrayByMonth()
    let datasets = []

    chartLabels.reverse()

    chartLabels.forEach((label, index) => {
      const dayLeads = leadsOfMonth.filter(
        lead => moment(lead.created_date).format('MM/DD') === label
      )
      datasets[index] = { name: label, leads: dayLeads.length }
    })

    return datasets
  }

  mountLeadsPerMonthChart = () => {
    const { leadsOfMonth, loadingLeadsPerMonth } = this.props
    if (leadsOfMonth) {
      const data = this.mountDataSet()
      return (
        <div style={{ width: '100%', height: '100%' }}>
          <Spin spinning={loadingLeadsPerMonth} tip="Loading report...">
            <BarChart
              width={500}
              height={200}
              data={data}
              margin={{ top: 20, right: 20, left: 20, bottom: 20 }}
            >
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis dataKey="name" />
              <YAxis />
              <Tooltip />
              <Bar dataKey="leads" fill="#8884d8" />
            </BarChart>
          </Spin>
        </div>
      )
    }
  }

  mountFunnel = () => {
    const { leadsStatusCount } = this.props
    if (leadsStatusCount) {
      const dataGtech = [
        { label: 'Research', value: leadsStatusCount.research },
        { label: 'Estimate', value: leadsStatusCount.estimate },
        { label: 'Proposal', value: leadsStatusCount.proposal },
        { label: 'Contract', value: leadsStatusCount.contract },
        { label: 'Complete', value: leadsStatusCount.complete }
      ]

      const options = {
        chart: {
          width: 300,
          height: 200,
          curve: { enabled: true },
          bottomPinch: 1,
          fill: { type: 'gradient' },
          highlight: true
        },
        block: {
          dynamicHeight: false,
          minHeight: 15
        }
      }

      const chart = new D3Funnel(this.funnelRef.current)
      chart.draw(dataGtech, options)
    }
  }

  render() {
    const { detailShowing, toggleDetails } = this.props
    return (
      <div>
        <div className={detailShowing ? 'jobGroup' : 'jobGroup hiddenStyle'}>
          <div className="row">
            <div className="col-6">
              <div className="jobsBar">Lead Per Month</div>
              {this.mountLeadsPerMonthChart()}
            </div>
            <div className="col-6">
              <div className="jobsBar">Conversion Chart</div>
              <div ref={this.funnelRef} style={{ textAlign: 'center' }} />
            </div>
          </div>
        </div>
        <div
          className={detailShowing ? 'toggleVisibilityBar' : 'toggleVisibilityBar rotateDiv'}
          onClick={toggleDetails}
          id="taskHeader"
        />
      </div>
    )
  }
}

export default ColapsePanel



// WEBPACK FOOTER //
// ./src/components/dashboard/ColapsePanel.js